<template>
  <partner-layout @scrolled-to-bottom="handleScrolledToBottom">
    <template #default>
      <main-title>Мои проекты</main-title>
      <horizontal-filter>
        <template #default>
          <filter-item path="/partner/requests" text="Запросы" />
          <filter-item path="/partner/projects" text="Мои проекты" />
        </template>
        <template #right>
          <label class="panel__total-items" v-if="totalItems">
            Всего: {{ totalItems }}
          </label>
          <switch-view-buttons />
        </template>
      </horizontal-filter>
      <projects-filter
        :status-list="statusList"
        @update-filter="updateFilter"
      />
      <infinite-grid-layout
        :get-items="api.project.projectStats"
        :url-params="urlParams"
        :scroll-bottom="scrollBottom"
        :one-column="route.hash === '#table'"
        entity="projects"
        @update-total-count="handleUpdateTotalCount"
      >
        <template #table-header v-if="route.hash === '#table'">
          <project-table-header />
        </template>
        <template #table-item="slotProps">
          <template v-if="route.hash === '#table'">
            <router-link :to="getLink(slotProps.item)">
              <project-table-item :project="slotProps.item" />
            </router-link>
          </template>
          <template v-else>
            <router-link :to="getLink(slotProps.item)">
              <project-card :project="slotProps.item" />
            </router-link>
          </template>
        </template>
      </infinite-grid-layout>
    </template>
  </partner-layout>
</template>

<script setup>
  import { onMounted, ref, watch } from 'vue';
  import { useRoute } from 'vue-router';
  import { useApi } from '@/api/use-api';
  import PartnerLayout from '@/layouts/PartnerLayout';
  import MainTitle from '@/components/titles/MainTitle';
  import HorizontalFilter from '@/components/filter/horizontal/HorizontalFilter';
  import FilterItem from '@/components/filter/components/FilterItem';
  import SwitchViewButtons from '@/components/switch-view/SwitchViewButtons';
  import ProjectCard from '@/components/projects/components/ProjectCard.vue';
  import { PROJECT_TAB_ALL } from '@/constants/project-tab';
  import {
    PROJECT_STATUS_ACCEPTANCE,
    PROJECT_STATUS_AGREEMENT,
    PROJECT_STATUS_IN_WORK,
  } from '@/api/models/ProjectStatus';
  import ProjectsFilter from '@/components/projects/components/ProjectsFilter.vue';
  import {
    PROJECT_STATUS_NAME_ACCEPTANCE,
    PROJECT_STATUS_NAME_AGREEMENT,
    PROJECT_STATUS_NAME_CLOSED,
    PROJECT_STATUS_NAME_DRAFT,
    PROJECT_STATUS_NAME_IN_WORK,
  } from '@/constants/project-status';
  import InfiniteGridLayout from '@/components/infinite-grid/InfiniteGridLayout.vue';
  import ProjectTableItem from '@/components/projects/components/ProjectTableItem.vue';
  import ProjectTableHeader from '@/components/projects/components/ProjectTableHeader.vue';

  const route = useRoute();
  const api = useApi();

  const urlParams = ref(null);
  const totalItems = ref(0);
  const scrollBottom = ref(0);
  const statusList = [
    PROJECT_STATUS_NAME_DRAFT,
    PROJECT_STATUS_NAME_AGREEMENT,
    PROJECT_STATUS_NAME_IN_WORK,
    PROJECT_STATUS_NAME_ACCEPTANCE,
    PROJECT_STATUS_NAME_CLOSED,
  ];

  onMounted(() => {
    urlParams.value = new URLSearchParams({
      tab: PROJECT_TAB_ALL,
      role: route.meta.role,
      sort: '-id',
    });
    if (route.query.textSearch) {
      urlParams.value.set('textSearch', route.query.textSearch);
    }
  });

  watch(
    () => route.hash,
    async () => {
      updateFilter(new URLSearchParams([...urlParams.value]));
    }
  );

  const updateFilter = (filterParams) => {
    urlParams.value = filterParams;
  };

  const handleScrolledToBottom = (value) => {
    scrollBottom.value = value;
  };

  const handleUpdateTotalCount = (value) => {
    totalItems.value = value;
  };

  const getLink = (project) => {
    if (project.projectStatusId === PROJECT_STATUS_AGREEMENT) {
      return `/partner/project/${project.id}/form#10`;
    } else if (project.projectStatusId === PROJECT_STATUS_ACCEPTANCE) {
      return `/partner/project/${project.id}/agreement`;
    } else if (project.projectStatusId === PROJECT_STATUS_IN_WORK) {
      return `/partner/project/${project.id}/management`;
    } else {
      return `/partner/project/${project.id}/form`;
    }
  };
</script>

<style lang="scss" scoped>
  .panel__total-items {
    align-self: center;
  }
</style>
